<template>
  <div class="flex items-center justify-between mx-4 mt-4 overflow-auto text-gray-700 bg-white shadow rounded-2xl">
    <input v-model="from" class="p-1 text-lg" type="date" placeholder="Filter From">
    <i class="px-2 text-xl text-gray-600 ion-md-arrow-forward"></i>
    <input v-model="to" class="p-1 text-lg" type="date" placeholder="Filter To">
    <button @click="filter" class="px-4 py-3 text-lg leading-none text-white bg-slate-500">Filter</button>
  </div>
</template>

<script>
export default {
  name: 'FromToDate',

  data() {
    return {
      from: null,
      to: null,
    };
  },

  methods: {
    filter() {
      if (this.from && this.to) {
        this.$emit('filter', this.from, this.to);
      }
    },
  },

  created() {
    let today = new Date();
    this.to = today.toISOString().substr(0, 10);
    today.setDate(today.getDate() - 7);
    this.from = today.toISOString().substr(0, 10);
  }
}
</script>
